import { FC } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Button, FormTextArea, useModal, useToast } from '../../../../../../components'
import { ButtonType, formatDateTime, ID, showError } from '../../../../../../../_metronic/helpers'
import { registrarReplica } from '../../core/_requests'

type Props = {
  atendimentoId: ID
  prazoReplica?: string
}

const replicaSchema = Yup.object().shape({
  observacao: Yup.string().trim().required('Escreva a réplica ao parecer'),
})

/**
 * Réplica do solicitante ao parecer: a interconsulta volta ao mesmo teleconsultor, que responde
 * num novo parecer. Só texto; o backend valida autoria, situação e prazo (422 com mensagem).
 */
export const ReplicaModal: FC<Props> = ({ atendimentoId, prazoReplica }) => {
  const { closeModal } = useModal()
  const { showToast } = useToast()

  const formik = useFormik({
    initialValues: { observacao: '' },
    validationSchema: replicaSchema,
    onSubmit: async ({ observacao }) => {
      try {
        await registrarReplica(atendimentoId, observacao.trim())
        showToast({
          variant: 'success',
          title: 'Réplica enviada',
          description: 'Você será notificado quando o novo parecer for assinado.',
        })
        closeModal()
      } catch (error) {
        showError(error)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <p className='text-gray-800 mb-5'>
        A interconsulta volta para o mesmo teleconsultor, que responde num novo parecer. O parecer
        atual continua disponível.
        {prazoReplica && (
          <>
            {' '}
            Prazo para replicar: <strong>{formatDateTime(prazoReplica)}</strong>.
          </>
        )}
      </p>
      <FormTextArea
        formik={formik}
        name='observacao'
        label='Réplica'
        placeholder='Descreva a dúvida que ficou ou o complemento que você precisa'
        isRequired
        rows={6}
      />
      <div className='d-flex justify-content-end gap-3 pt-6'>
        <Button className='btn-secondary' onClick={closeModal} disabled={formik.isSubmitting}>
          Cancelar
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          Enviar réplica
        </Button>
      </div>
    </form>
  )
}
